import axios from "axios";
import { reactive, toRefs, computed, provide, inject } from "@vue/composition-api";

export const state = reactive({
    templates: []
});

export const actions = {
    async fetchEmailAutomationTemplates(company_id) {
        const { data } = await axios.get(`/email_automation/template/list/${company_id}`)
        state.templates = data
    },
    async fetchEmailAutomationTemplate(template_id) {
        const { data } = await axios.get(`/email_automation/template/${template_id}`)
        return data
    },
    async deleteEmailAutomationTemplate(template_id, force) {
        return await axios.delete(`/email_automation/template/${template_id}`, { params: { force }})
    },
    async saveEmailAutomationTemplate(template, force) {
        if (template.id) {
            return await axios.put(`/email_automation/template/${template.id}`, { template, force });
        } else {
            return await axios.post('/email_automation/template', { template, force });
        }
    },
    async sendTestEmail(template){
        return await axios.post(`/email_automation/template/send_test_email`, template);
    }
};

export const getters = {
    emailAutomationTemplates: computed(() => state.templates),
};

export const key = Symbol("EmailAutomationModule");

export const provideEmailAutomation = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
